import{e as t,g as o,m as a}from"./chunk-HBP5N4FR.js";var p={};o(p,{css:()=>e,default:()=>n});var e,n,l=t(()=>{a();e=`.dapp-core-component__TransactionDataStyles__data {
  display: flex;
  flex-direction: column;
  text-align: left;
}
.dapp-core-component__TransactionDataStyles__data .dapp-core-component__TransactionDataStyles__label {
  margin-bottom: 8px;
  color: #a3a3a3;
  font-size: 12px;
  line-height: 1;
  font-weight: 400;
  display: block;
}
.dapp-core-component__TransactionDataStyles__data .dapp-core-component__TransactionDataStyles__value {
  min-height: 80px;
  font-size: 14px;
  padding: 12px;
  line-height: 1.25;
  border-radius: 6px;
  border: 1px solid #262626;
  word-break: break-all;
}`;document.head.appendChild(document.createElement("style")).appendChild(document.createTextNode(e));n={data:"dapp-core-component__TransactionDataStyles__data",label:"dapp-core-component__TransactionDataStyles__label",value:"dapp-core-component__TransactionDataStyles__value"}});export{e as a,n as b,p as c,l as d};
//# sourceMappingURL=chunk-THKMTSLG.js.map
